var _circle, _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 77,
    viewBox: "0 0 97 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5098,
    cy: 30.2559,
    r: 24,
    fill: "#EF183E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27060_4824)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.2551,
    cy: 38.2551,
    r: 34.2551,
    fill: "#FCFDFC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27060_4824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5093 65.3789L60.5098 65.3789L84.5098 41.3794L84.5093 65.3789Z",
    fill: "#001234"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2559 30.2559C34.9419 30.2559 32.2559 32.0459 32.2559 34.2559C32.2559 36.4659 34.9419 38.2559 38.2559 38.2559C41.5699 38.2559 44.2559 40.0459 44.2559 42.2559C44.2559 44.4659 41.5699 46.2559 38.2559 46.2559V30.2559ZM38.2559 30.2559C40.4759 30.2559 42.4159 31.0599 43.4539 32.2559L38.2559 30.2559ZM38.2559 30.2559V28.2559V30.2559ZM38.2559 30.2559V46.2559V30.2559ZM38.2559 46.2559V48.2559V46.2559ZM38.2559 46.2559C36.0359 46.2559 34.0959 45.4519 33.0579 44.2559L38.2559 46.2559ZM56.2559 38.2559C56.2559 40.6197 55.7903 42.9603 54.8857 45.1442C53.9811 47.328 52.6552 49.3123 50.9838 50.9838C49.3123 52.6552 47.328 53.9811 45.1442 54.8857C42.9603 55.7903 40.6197 56.2559 38.2559 56.2559C35.8921 56.2559 33.5514 55.7903 31.3676 54.8857C29.1837 53.9811 27.1994 52.6552 25.5279 50.9838C23.8565 49.3123 22.5306 47.328 21.626 45.1442C20.7214 42.9603 20.2559 40.6197 20.2559 38.2559C20.2559 33.482 22.1523 28.9036 25.5279 25.5279C28.9036 22.1523 33.482 20.2559 38.2559 20.2559C43.0298 20.2559 47.6081 22.1523 50.9838 25.5279C54.3594 28.9036 56.2559 33.482 56.2559 38.2559Z",
    stroke: "#001234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27060_4824",
    x: 0,
    y: 0,
    width: 76.5098,
    height: 76.5098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4824"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27060_4824",
    x: 56.5098,
    y: 37.3789,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4824"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar_sign.75ab1bc19892d3c28cf5e76f798a96d4.svg";
export { ForwardRef as ReactComponent };